import { RouteObject } from "react-router-dom";
// reports
import { TenantMemberDepositListPage } from "@/pages/tenant/reports/member-deposit";
import { TenantMemberWithdrawListPage } from "@/pages/tenant/reports/member-withdraw";
import { TenantSelfDepositListPage } from "@/pages/tenant/reports/self-deposit";
import { TenantSelfWithdrawListPage } from "@/pages/tenant/reports/self-withdraw";
import { TenantDailyReportDepositListPage } from "@/pages/tenant/reports/daily-deposit";
import { TenantDailyReportWithdrawListPage } from "@/pages/tenant/reports/daily-withdraw";
// management
import { TenantManageCreateMemberDepositPage } from "@/pages/tenant/management/create-member-deposit";
import { TenantManageCreateMemberWithdrawPage } from "@/pages/tenant/management/create-member-withdraw";
import { TenantManageMembersPage } from "@/pages/tenant/management/members";
import { TenantManageOptionsPage } from "@/pages/tenant/management/options";
import { TenantManageOperationsPage } from "@/pages/tenant/management/operations";

export const tenantRoutes: RouteObject[] = [
  {
    path: "tenant",
    children: [
      {
        path: "reports",
        children: [
          {
            path: "member-deposit",
            element: <TenantMemberDepositListPage />,
          },
          {
            path: "member-withdraw",
            element: <TenantMemberWithdrawListPage />,
          },
          {
            path: "self-deposit",
            element: <TenantSelfDepositListPage />,
          },
          {
            path: "self-withdraw",
            element: <TenantSelfWithdrawListPage />,
          },
          {
            path: "daily-deposit",
            element: <TenantDailyReportDepositListPage />,
          },
          {
            path: "daily-withdraw",
            element: <TenantDailyReportWithdrawListPage />,
          },
        ],
      },
      {
        path: "management",
        children: [
          {
            path: "create-member-deposit",
            element: <TenantManageCreateMemberDepositPage />,
          },
          {
            path: "create-member-withdraw",
            element: <TenantManageCreateMemberWithdrawPage />,
          },
          {
            path: "members",
            element: <TenantManageMembersPage />,
          },
          {
            path: "options",
            element: <TenantManageOptionsPage />,
          },
          {
            path: "operations",
            element: <TenantManageOperationsPage />,
          },
        ],
      },
    ],
  },
];
